import { ANALYTICS } from '../Admin/analyticsTokens';
import { DASH } from '../Dashboard/tokens';

export const DATA_REVIEW = {
  stripBg: ANALYTICS.yellow100,
  stripFg: ANALYTICS.yellow900,
  stripIcon: DASH.warnChip.dot,
  ink: ANALYTICS.ink,
  muted: ANALYTICS.muted,
  divider: ANALYTICS.divider,
  success: ANALYTICS.green700,
  diffMark: DASH.warnChip.bg,
} as const;

export const CONTACT_FLASHLIGHT_URL = 'https://4xu6wknl4ap.typeform.com/to/BocJcZMN#user_id=';
export const MATCHES_ROUTE = '/data/matches';
